package fr.labodoc.healthProfessional.webApp.utils

import io.kvision.core.Widget

fun Widget.toggleCssClass(css: String) {
  if (hasCssClass(css))
    removeCssClass(css)
  else
    addCssClass(css)
}
